import { useState } from "react";

import {
  makeGetApiCall,
  makePostApiCall,
  makePutApiCall,
} from "../../../shared/makeApiCall";
import CategoryDetailsForm from "../../../components/forms/setup/categories/CategoryDetailsForm";
import { BannerNotificationType } from "../../../components/SimpleNotification";
import DeleteConfirmationForm from "../../../components/forms/DeleteConfirmationForm";
import { updateObjectInArray } from "../../../shared/utility";

export function CategoriesViewModel(logout) {
  const [classes, setClasses] = useState([]);
  const [loading, setLoading] = useState(false);
  const [categories, setCategories] = useState({
    data: [],
  });
  const [showSimpleNotification, setShowSimpleNotification] = useState({
    show: false,
    message: null,
    title: null,
    type: BannerNotificationType.Success,
  });
  const [slideOver, setSlideOver] = useState({
    childComponent: null,
    open: false,
  });
  const [emptyModal, setEmptyModelOpen] = useState({
    open: false,
    childComponent: null,
  });

  const getCategories = async function (search, page) {
    setLoading(true);

    let callResult = await makePostApiCall(
      `categories?page=${page}&search=${search}`
    );
    setLoading(false);
    if (callResult.success) {
      setCategories(callResult.data);
    } else {
      if (callResult.errorStatus === 401) {
        logout();
      }
    }
  };

  const getClassesForDropdown = async function () {
    let callResult = await makeGetApiCall("classesForDropdown");
    if (callResult.success) {
      setClasses(callResult.data);
    } else {
      if (callResult.errorStatus === 401) {
        logout();
      }
    }
  }

  const createCategory = async function (values) {
    const payload = { ...values };
    let callResult = await makePostApiCall("categories/create", payload);

    if (callResult.success) {
      setShowSimpleNotification({
        show: true,
        title: "Category added",
        type: BannerNotificationType.Success,
      });
      setSlideOver({
        childComponent: null,
        open: false,
      });
      setTimeout(function () {
        getCategories("", 1);
      }, 1000);
    } else {
      if (callResult.errorStatus === 401) {
        logout();
      }
    }
  };

  const updateCategory = async function (values, index) {
    let callResult = await makePutApiCall(`categories/${values.id}`, values);

    if (callResult.success) {
      setShowSimpleNotification({
        show: true,
        title: "Category updated",
        type: BannerNotificationType.Success,
      });
      setSlideOver({
        childComponent: null,
        open: false,
      });

      const currentItems = [...categories.data];
      var payload = {
        index: index,
        item: callResult.data.item,
      };
      const newItems = updateObjectInArray(currentItems, payload);
      setCategories({ ...categories, data: newItems });
    } else {
      if (callResult.errorStatus === 401) {
        logout();
      }
    }
  };

  const openAddCategorySlideOver = (isEdit, category, index) => {
    setSlideOver({
      childComponent: (
        <CategoryDetailsForm
          category={category}
          classes={classes}
          isEdit={isEdit}
          setOpen={setSlideOver}
          actionCall={(payload) =>
            isEdit ? updateCategory(payload, index) : createCategory(payload)
          }
          title={isEdit ? `Update ${category.name}` : "Add new category"}
        />
      ),
      open: true,
    });
  };

  const deleteCategory = async function (id, index) {
    setLoading(true);

    let callResult = await makePostApiCall(`deleteCategory/${id}`);
    setLoading(false);
    if (callResult.success) {
      setEmptyModelOpen({
        open: false,
        childComponent: null,
      });

      const newItems = categories.data.filter((item) => item.id !== id);
      setCategories({ ...categories, data: newItems });

      setShowSimpleNotification({
        show: true,
        title: callResult.data.message,
        type: BannerNotificationType.Success,
      });
    } else {
      if (callResult.errorStatus === 401) {
        logout();
      }
    }
  };

  const askDeleteCategory = function (category, index) {
    setEmptyModelOpen({
      childComponent: (
        <DeleteConfirmationForm
          buttonMessage="Delete"
          confirmAction={() => deleteCategory(category.id, index)}
          message={`Are you sure you want to delete  ${category.name}?`}
          setOpen={setEmptyModelOpen}
          hideReason={true}
        />
      ),
      open: true,
    });
  };

  return {
    openAddCategorySlideOver,
    getCategories,
    loading,
    categories,
    setSlideOver,
    slideOver,
    setShowSimpleNotification,
    showSimpleNotification,
    setEmptyModelOpen,
    emptyModal,
    askDeleteCategory,
    getClassesForDropdown,
  };
}
